module.exports = __webpack_public_path__ + "fonts/ToyotaType-Light.baefbee.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/ToyotaType-Light.woff2
// module id = xkow
// module chunks = 13